
import Error from 'rde-view-common/components/SystemError';

export default {
  components: { Error },
  props: {
    error: {
      type: Object,
      default: null
    }
  }
};
